import { createContext } from 'react'
import { PageContextValue } from '../../../core/type'
import { Order, OrderEntry } from '../type'

export const OrderPageContext = createContext<PageContextValue<Order, OrderEntry>>({})
